import { PortalPartnerTypeEnum } from '@routellers/types/dist/partners-portal/enum/portal-partner-type.enum';
import {
    Anchor,
    Button,
    Card,
    PasswordInput,
    Stack,
    Text,
    TextInput,
    Title,
} from '@mantine/core';
import { useForm } from '@mantine/form';
import { notifications } from '@mantine/notifications';
import { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';

import { api } from '../api';
import { apiErrorMessage } from '../api/client';
import { t } from '../dictionary';

export const RegisterPage = () => {
    const navigate = useNavigate();
    const [loading, setLoading] = useState(false);

    const form = useForm({
        initialValues: {
            name: '',
            email: '',
            password: '',
        },
        validate: {
            name: (v) => (v.trim() ? null : 'Enter your name'),
            email: (v) => (/^\S+@\S+\.\S+$/.test(v) ? null : 'Enter a valid email'),
            password: (v) => (v.length >= 8 ? null : t.auth.passwordHint),
        },
    });

    const submit = async (values: typeof form.values) => {
        setLoading(true);

        try {
            await api.register({
                type: PortalPartnerTypeEnum.AUTHOR,
                name: values.name,
                email: values.email,
                password: values.password,
            });

            navigate(`/verify?email=${encodeURIComponent(values.email)}`);
        } catch (error) {
            notifications.show({ color: 'red', message: apiErrorMessage(error) });
        } finally {
            setLoading(false);
        }
    };

    return (
        <Card padding='xl' shadow='sm'>
            <form onSubmit={form.onSubmit(submit)}>
                <Stack gap='lg'>
                    <div>
                        <Title order={2}>{t.auth.registerTitle}</Title>
                        <Text c='dimmed' size='sm' mt={4}>
                            {t.auth.registerSubtitle}
                        </Text>
                    </div>

                    <TextInput
                        label={t.auth.fullName}
                        placeholder='Jane Doe'
                        {...form.getInputProps('name')}
                    />

                    <TextInput
                        label={t.auth.email}
                        placeholder='you@example.com'
                        autoComplete='email'
                        {...form.getInputProps('email')}
                    />

                    <PasswordInput
                        label={t.auth.password}
                        description={t.auth.passwordHint}
                        autoComplete='new-password'
                        {...form.getInputProps('password')}
                    />

                    <Text size='xs' c='dimmed'>
                        {t.auth.terms}
                    </Text>

                    <Button type='submit' loading={loading} fullWidth>
                        {t.auth.createAccountButton}
                    </Button>

                    <Text size='sm' c='dimmed' ta='center'>
                        {t.auth.haveAccount}{' '}
                        <Anchor component={Link} to='/login' fw={600}>
                            {t.auth.login}
                        </Anchor>
                    </Text>
                </Stack>
            </form>
        </Card>
    );
};
